import React, {Component} from 'react';
import Styles from './style.css';
import Header from "../../components/header/component";
import cx from "classnames";
import * as Icon from "react-feather";
import Footer from "../../components/footer/component";

class About extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {}

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className={Styles.app}>
                <Header view={"/about"} props={this.props}/>
                <div className={Styles.sectionOne}>
                    <img className={Styles.sectionOneRocket} src={require("../../assets/images/rocket.png")}/>
                    <div className={Styles.sectionOneText}>
                        ...Swedish Tech Mafia is on a mission to help entrepreneurs in creating tech wonders. We admire technology and borderless innovation. And naturally we promote future innovation; our in-house formula allows us to ship digital products up to the highest standards and in truly astonishing timeframes. This approach allows us to research, prototype, design, develop, legalise and deploy the next generation of digital platforms.
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Swedish Tech Mafia’s executive team has over 50 years combined experience in building state of the art digital platforms and advanced technical architectures. We configure ad-hoc teams and build and launch new ventures to the market in truly rapid timeframes. That’s how our incubator was created, and since has not only served to research and build digital products, but also in helping businesses and entrepreneurs to explore new opportunities and thrive with their new ventures.
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        We are always looking for like-minded, hardworking entrepreneurs to collaborate with. We know that the key to success is hard work and partner with the best.
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneQuote}>
                        “We are on a mission to help entrepreneurs in creating tech wonders”
                    </div>
                    <div className={Styles.sectionOneTitle}>
                        <div className={Styles.sectionOneTitleItem}><span className={Styles.sectionOneTitleItemGreen}>MEET</span> THE</div>
                        <div className={Styles.sectionOneTitleItem}>TEAM</div>
                    </div>
                    <div className={Styles.sectionOneTextBold}>
                        Stockholm branch
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Alex
                    </div>
                    <div className={Styles.sectionOneText}>
                        Serial entrepreneur and angel investor
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Jacek
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior developer with 20 years of hard-core back-end coding
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Dennis
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior developer with 8 years of hard-core back-end coding
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Raj
                    </div>
                    <div className={Styles.sectionOneText}>
                        Analyst with 5 years of conversion driven digital marketing experience
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Niclas
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior designer with over 7 years of top branding
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Christian
                    </div>
                    <div className={Styles.sectionOneText}>
                        AI & machine learning expert with over 10 years experience
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Fredrik
                    </div>
                    <div className={Styles.sectionOneText}>
                        New-age vibe coder, always ahead of the curve
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneTextBold}>
                        Barcelona branch
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Andreas
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior product designer, serial entrepreneur and angel investor
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Harald
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior developer with 15 years of hard-core back-end and front-end coding
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Raj
                    </div>
                    <div className={Styles.sectionOneText}>
                        Junior developer 6 years of hard-core front-end coding
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneTextBold}>
                        Dubai branch
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Matt
                    </div>
                    <div className={Styles.sectionOneText}>
                        Full-stack developer, early AI adopter, product lead, serial entrepreneur and angel investor
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Fredrik
                    </div>
                    <div className={Styles.sectionOneText}>
                        AI & machine learning expert with over 10 years experience
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        John
                    </div>
                    <div className={Styles.sectionOneText}>
                        Digital marketing guru, angel investor and strategist
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Martin
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior full-stack developer with 7 years of hard-core back-end and front-end coding
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Chris
                    </div>
                    <div className={Styles.sectionOneText}>
                        Serial entrepreneur within real estate and tech
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Zeeshan
                    </div>
                    <div className={Styles.sectionOneText}>
                        Analyst with 8 years of design and digital marketing experience
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Patrick
                    </div>
                    <div className={Styles.sectionOneText}>
                        Investment banker and angel investor with over 15 years experience
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Claus
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior banker and entrepreneur within blockchain technology
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneTextBold}>
                        New York branch
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Chris & team
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior full-stack developers with focus on deep tech
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneTextBold}>
                        Manila branch
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Raj & team
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior content administrators profiling nearly anything consumable
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneTextBold}>
                        Colombo Branch
                    </div>
                    <br/>
                    <br/>
                    <div className={Styles.sectionOneText}>
                        Pravina & team
                    </div>
                    <div className={Styles.sectionOneText}>
                        Senior design gurus providing over 15 years of uncompromised digital design
                    </div>
                    <div className={Styles.sectionOneTitle}>
                        <div className={Styles.sectionOneTitleItem}><span className={Styles.sectionOneTitleItemGreen}>JOIN</span> THE</div>
                        <div className={Styles.sectionOneTitleItem}>MOVEMENT</div>
                    </div>
                    <div className={Styles.sectionOneText}>
                        We are always looking for the best talents out there. Tech gurus, business developers, coders, all-nigh hackers, product designers, project managers… if you think you are made of the right stuff and most of all YOU LOVE WHAT YOU DO, hit us with your CV!
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div onClick={() => this.props.history.push("/contact")} className={Styles.sectionOneButton}>
                        Join us
                    </div>
                </div>
                <Footer props={this.props}/>
            </div>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/about/component.js